var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumedEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_0_221_1867_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 68,
    height: 68
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      height: "100%",
      width: "100%"
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 10,
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(-90 24 24)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.5H26M22 25.5H26M22 21.5H26M25 14H23M30 29.2V21.8C30 20.1198 30 19.2798 29.673 18.638C29.3854 18.0735 28.9265 17.6146 28.362 17.327C27.7202 17 26.8802 17 25.2 17H22.8C21.1198 17 20.2798 17 19.638 17.327C19.0735 17.6146 18.6146 18.0735 18.327 18.638C18 19.2798 18 20.1198 18 21.8V29.2C18 30.8802 18 31.7202 18.327 32.362C18.6146 32.9265 19.0735 33.3854 19.638 33.673C20.2798 34 21.1198 34 22.8 34H25.2C26.8802 34 27.7202 34 28.362 33.673C28.9265 33.3854 29.3854 32.9265 29.673 32.362C30 31.7202 30 30.8802 30 29.2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_221_1867_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(-90 24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumedEnergyIcon);
export default __webpack_public_path__ + "static/media/consumedEnergyIcon.bc3e143cbd9dd366cd5c735a996d9d26.svg";
export { ForwardRef as ReactComponent };